export default {
  props: {
    rowIndex: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    rowActions: {
      type: Array,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  }
};